<script>

import WorldMap from '@components/worldmap'
import MultiColumn from '@components/multicolumn'
import TopAlerts from '@components/topalerts'
import TopIndicators from '@components/topindicators'
import Vindicator from '@components/vindicator'
import DPie from '@components/dpie'
import DBar from '@components/dbar'
import SBar from '@components/sbar'
import DMixed from '@components/mixed'
import OwnTable from '@components/owntable'
import Recommendations from '../apps/recommendations/client'

/**
 * Dashboard-1 Component
 */
export default {
  components: {
    WorldMap, MultiColumn, TopAlerts, TopIndicators, Vindicator, DPie, DBar, SBar, DMixed, OwnTable, Recommendations
  },
  props: {
    title: {
      type: String,
      default: ''
    },
		  id: {
			  type: String,
      required: true
    },
    component: {
      type: String,
      required: true
    },
    source: {
      type: String,
      default: ''
    },
    series: {
      type: Array,
      default: function () { return [{}] }
    },
    cols: {
      type: String,
      default: 'col-md-4'
    },
    type: {
      type: String,
      default: ''
    },
    cardStyle: {
      type: String,
      default: 'height:300px;overflow:auto'
    },
    labels: {
      type: String,
      default: 'default'
    },
    colors: {
			  type: Array,
      default: function () { return [] }
    },
    colorsByLabel: {
      type: Object,
      default: function () { return {} }
    },
    trend: {
      type: Boolean,
      default: false
    },
    wclass: {
			  type: String,
      default: ''
    },
    range: {
		  	type: Boolean,
			  default: false
    },
    start: {
      type: Number,
      default: 0
    },
    end: {
      type: Number,
      default: 0
    },
    auxBool: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      default: ''
    },
    limit: {
      type: Number,
      default: 30
    }
  },
  provide: function () {
    return {
      getWidth: this.getWidth
    }
  },
  data () {
    return {
      titleTail: '',
      renderedTitle: '',
      appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
      width: 0
    }
  },
  computed: {

  },
  mounted () {
    this.renderedTitle = this.title.replace('#{limit}', this.limit)
  },
  beforeMount: function () {
    window.addEventListener('resize', this.handleResize)
  },
  methods: {
    getWidth () {
      return this.$el.clientWidth
    },
    finished (id, ok, aux, titleTail = '') {
      console.log(titleTail)
      if (titleTail.length > 0) { this.titleTail = titleTail }
      this.$emit('finished', id, ok, aux)
    }

  }
}
</script>

<template>
  <div :class="cols">
    <template v-if="component !== 'vindicator'">
      <span>
        <h5>{{ renderedTitle + titleTail }}</h5>
      </span>
      <b-card :id="id" no-body class="text-center" :style="cardStyle">
        <template v-if="component == 'worldmap'">
          <WorldMap :id="id" :source="source" @finished="finished" />
        </template>
        <template v-else-if="component == 'multicolumn'">
          <MultiColumn :id="id" :source="source" :start="start" :end="end" :range="range" :error="error" :limit="limit"
            @finished="finished" />
        </template>
        <template v-else-if="component === 'topindicators'">
          <TopIndicators :id="id" :source="source" @finished="finished" />
        </template>
        <template v-else-if="component === 'topalerts'">
          <TopAlerts :id="id" :source="source" @finished="finished" />
        </template>
        <template v-else-if="component === 'dpie'">
          <DPie :id="id" :source="source" :type="type" :colors="colors" :colors-by-label="colorsByLabel" :start="start"
            :end="end" :range="range" @finished="finished" />
        </template>
        <template v-else-if="component === 'dbar'">
          <DBar :id="id" :source="source" :type="type" :colors="colors" :labels="labels" :start="start" :end="end"
            :range="range" @finished="finished" />
        </template>
        <template v-else-if="component === 'sbar'">
          <SBar :id="id" :source="source" :type="type" :colors="colors" :labels="labels" :start="start" :end="end"
            :range="range" :aux-bool="auxBool" @finished="finished" />
        </template>
        <template v-else-if="component === 'recommendations'">
          <div style="margin:20px 20px -10px 20px;text-align: left">
            <Recommendations :id="id" :url="source" :start="start" :end="end" :action="false" :show-datetime="false"
              @finished="finished" />
          </div>
        </template>
        <template v-else-if="component === 'mixed'">
          <div style="margin:20px 20px -10px 20px;text-align: left">
            <DMixed :id="id" :series="series" :type="type" :colors="colors" :start="start" :end="end"
              :card-style="cardStyle" :action="false" :show-datetime="false" @finished="finished" />
          </div>
        </template>
        <template v-else-if="component === 'owntable'">
          <OwnTable :id="id" :source="source" :start="start" :end="end" :range="range" @finished="finished" />
        </template>
        <template v-else />
      </b-card>
    </template>
    <template v-else>
      <Vindicator :id="id" :source="source" :title="title" :trend="trend" :start="start" :end="end" :range="range"
        :wclass="wclass" @finished="finished" />
    </template>
  </div>
</template>

<style>
  /* .widget {
	max-width: 600px;
  } */

  .scrollable_card_medium {
        max-height: 360px;
  }

  .big_number {
      font-size: 4em;
      font-weight: 700;
      padding-right: 10px;
  }
</style>
